import { IGoogleEvent, IAppParams } from "../models";
import { gaEvents } from "../config";

export function initGoogleTracking() {
	if (!window["dataLayer"]) {
		let dataLayer: IGoogleEvent[] = [];
		window["dataLayer"] = dataLayer;
	}
}

export function addItemToGoogleTracking(appParams: IAppParams, key: string, options: IGoogleEvent, eventLabelTransform: Function = null) {
	let [gaEvent] = gaEvents.filter(event => key === event.key);
	if (gaEvent) {
		let eventObj = { ...appParams, ...gaEvent, ...options };
		delete eventObj.key;
		if (!eventLabelTransform && gaEvent.eventLabelTransform) {
			eventLabelTransform = gaEvent.eventLabelTransform;
		}
		if (eventLabelTransform) {
			eventObj.eventLabel = eventLabelTransform(eventObj.eventLabel);
		}
		window["dataLayer"].push(eventObj);
		console.log("Event added to dataLayer:", window["dataLayer"]);
	}
}


// WEBPACK FOOTER //
// ./src/client/utils/google-tracking-helper.ts